import React from "react";
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import classnames from 'classnames';
import { Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import SanitizedLink from "../common/sanitizedLink";

class SourceLinks extends React.Component {

    render() {
        if (isNullOrUndefined(this.props.sourceLinks) || !Array.isArray(this.props.sourceLinks))
            return null;

        const czLinks = this.props.sourceLinks.filter(f => f.country === "CZ");
        const skLinks = this.props.sourceLinks.filter(f => f.country === "SK");

        return (
            <div className={classnames("qs-links")}>
                {czLinks.length > 0 && <>
                    <span className={classnames("qs-links-label")}><Translate id="Report.Quick.Link.CZSources" />:&nbsp;</span>
                    <div >{czLinks.map(l => this.renderLink(l))}</div>
                </>}
                {skLinks.length > 0 && <>
                    <span className={classnames("qs-links-label")}><Translate id="Report.Quick.Link.SKSources" />:&nbsp;</span>
                    <div>{skLinks.map(l => this.renderLink(l))}</div>
                </>}
            </div>)
    }

    renderLink = (link) => {
        return (
            <SanitizedLink
                key={link.label}
                title={isNullOrUndefined(link.tooltip) ? undefined : link.tooltip}
                link={link.link}
                label={link.label}
            />
        )
    }
}

export default withLocalize(connect(
    state => state.report
)(SourceLinks))